import { Reveal } from "./Reveal";
import { siteConfig } from "@/config/siteConfig";

export const Founder = () => (
  <section id="founder" className="border-t border-slate-200 bg-white py-24 sm:py-32" data-testid="founder-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <div className="grid gap-10 rounded-2xl border border-slate-200 bg-slate-50 p-8 sm:p-12 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-3">
            <div className="grid h-24 w-24 place-items-center overflow-hidden rounded-2xl border border-slate-200 bg-white">
              <img
                src={siteConfig.brand.logoUrl}
                alt="ORIVA AI logo"
                loading="lazy"
                className="h-20 w-20"
              />
            </div>
          </div>
          <div className="lg:col-span-9">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">About the founder</p>
            <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl" data-testid="founder-name">
              {siteConfig.founder.name}
            </h2>
            <p className="mt-1 text-sm font-medium text-oriva-blue">{siteConfig.founder.role}</p>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600">
              Massaid created ORIVA with a simple goal: bring AI-powered study, content
              creation and professional productivity tools together in one platform — so
              students, creators and professionals don't need five different apps to get
              real work done. ORIVA is built in India, for everyone.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
